import { transparentize } from 'polished';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import Icon from 'core/components/Icon';
import { Devices } from 'core/styles';

export const SubNavigationItem = styled(NavLink)`
  display: flex;
  align-items: center;
  height: 100%;
  text-transform: capitalize;
  margin-right: 5vw;
  font-size: 16px;

  &:last-child {
    margin-right: 0;
  }

  &.active {
    color: ${props => props.theme.colors.brandPrimary};
  }
`;

export const SubNavigationBar = styled.div`
  display: flex;
  justify-content: center;
  height: 70px;
  background-color: #fff;
  
`;

export const MainNavigationLogo = styled.div`
  width: 172px;
  height: 30px;
  margin-left: 25px;
  background: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTcyIiBoZWlnaHQ9IjMwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIGZpbGwtcnVsZT0ibm9uemVybyIgZmlsbD0ibm9uZSI+PGcgZmlsbD0iI0ZGRiI+PHBhdGggZD0iTTU0LjI2OSAxMmMwLTMuODU3LTIuOTk5LTQuMzg1LTUuODk4LTQuMzg1aC04LjY2NnYxNC40NGgzLjA5N3YtNS41MzloNC4xMmw0LjA4NSA1LjUzOWgzLjgyMmwtNC4zNS01Ljc3YzEuOTQ1LS4yMyAzLjc5LTEuNjE1IDMuNzktNC4yODV6bS0xMS40NjctMS43OGg1LjE0YzIuNDM5IDAgMy4yMy40MjggMy4yMyAxLjgxM3MtLjc5MSAxLjg0Ni0zLjIzIDEuODQ2aC01LjE0di0zLjY2ek03Mi43MjEgMTUuNjI2YzAgMi4wMTEtLjUyNyA0LjA1NS00LjU4IDQuMDU1LTQuMDIgMC00LjU4LTIuMDQ0LTQuNTgtNC4wNTVWNy41ODJoLTMuMDk3djguMjQyYzAgNC4zNTIgMi41NyA2LjU2IDcuNjQ0IDYuNTZzNy42NDQtMi4yMDggNy42NDQtNi41NlY3LjU4MmgtMy4wOTd2OC4wNDRoLjA2NnpNOTUuNjIxIDE0LjMwOGMuNzU4LS41MjggMS40NS0xLjI1MyAxLjQ1LTIuOTAxIDAtMi41MzktMS44NzgtMy43OTItNS43LTMuNzkyaC04LjY2NnYxNC40NGg5LjE5M2MzLjYyNSAwIDUuNzMzLTEuNTUgNS43MzMtNC4yNTMgMC0xLjY4MS0uOTg4LTIuOTM0LTIuMDEtMy40OTR6bS00LjA1Mi0xLjEyMWgtNS43NjdWMTAuMjJoNS43NjdjMi4wMSAwIDIuNDM4LjU5MyAyLjQzOCAxLjQ4My0uMDMzLjg5LS40MjggMS40ODQtMi40MzggMS40ODR6bS01Ljc2NyAyLjYwNGg1LjgzMmMyLjAxIDAgMi45LjU2IDIuOSAxLjc4IDAgMS4zMi0uODI0IDEuODQ3LTIuOSAxLjg0N2gtNS44MzJWMTUuNzl6TTEwMy42OTQgNy42MTZoMy4wOTd2MTQuNDRoLTMuMDk3ek0xMjUuNTczIDE2LjgxM2MtLjI2My45OS0xLjU0OCAyLjg2OC00Ljc0NSAyLjg2OC0zLjE2MyAwLTUuMjA2LTEuODc5LTUuMjA2LTQuNzggMC0zLjE5OCAxLjkxMS00Ljk0NSA1LjM3MS00Ljk0NSAyLjk2NiAwIDQuMTg1IDEuNzE0IDQuMzgyIDIuMzc0bC4wMzMuMTMyaDMuMDk4bC0uMDY2LS4yOTdjLTEuMTItNC4wNTUtNC43NDUtNC45MTItNy41NzktNC45MTItNS4yMzkgMC04LjM2OSAyLjczNi04LjM2OSA3LjM1MSAwIDQuODE0IDMuMTMgNy44MTQgOC4xMzkgNy44MTQgMi42MzYgMCA3LjIxNi0uNzI2IDguMDQtNS41MDZsLjAzMi0uMTk4aC0zLjA5N2wtLjAzMy4xek0xNDIuMzEyIDcuMjUzYy01LjM3MSAwLTguNTY3IDIuODY4LTguNTY3IDcuNjgxIDAgMS4yNTMuNDI4IDcuNDg0IDguNTY3IDcuNDg0czguNTY3LTYuMjMxIDguNTY3LTcuNDg0YzAtNC44MTMtMy4xOTYtNy42ODEtOC41NjctNy42ODF6bTUuNDcgNy41MTZjMCA0LjQ1LTMuODIzIDQuOTEyLTUuNDcgNC45MTItMS42NDggMC01LjQ3LS40OTQtNS40Ny00LjkxMiAwLTMuMDMzIDIuMDQzLTQuODEzIDUuNDctNC44MTMgMy40MjcgMCA1LjQ3IDEuODEzIDUuNDcgNC44MTN6TTE2OC44NyA3LjYxNXY5LjkyM2wtOS4xOTMtOS45MjNoLTMuMTY0djE0LjQ0aDIuOTY2VjExLjczNmw5LjU4OCAxMC4zMTloMi43NjhWNy42MTV6Ii8+PC9nPjxnIGZpbGw9IiMwMEE2OUEiPjxwYXRoIGQ9Ik0zMS43MzEgMjAuNDA3Yy0uNDk0LTEuOTEyLTEuNzQ2LTMuNDk1LTMuNDI3LTQuNDg0bC05LjAyOC01LjI0Mi0uODU3LS40OTQtMS44NDUtMS4wNTV2NS44MzVsOS4yMjYgNS4zNGEyLjM2IDIuMzYgMCAwIDEgMS4wODcgMS40MThjLjE2NS41OTQuMDY2IDEuMjItLjIzIDEuNzhhMi4zNiAyLjM2IDAgMCAxLTEuNDE3IDEuMDg4IDIuNjggMi42OCAwIDAgMS0xLjI1MiAwbC0uMjMtLjA2Ni01LjA0MiAyLjkzNSAyLjI0IDEuMjg1YzEuMTIuNjYgMi40MDYuOTkgMy42OS45OS42NiAwIDEuMjg2LS4xIDEuOTEyLS4yNjQgMS45MTEtLjQ5NSAzLjQ5My0xLjc0OCA0LjQ4MS0zLjQyOS45NTYtMS43NDcgMS4yMi0zLjc1OC42OTItNS42Mzd6Ii8+PHBhdGggZD0iTTEzLjc0IDE4LjA2NlY3LjM4NWEyLjM1IDIuMzUgMCAwIDEgMi4zNC0yLjM0MWMxLjA1NCAwIDEuOTc3LjcyNSAyLjI0IDEuNzE0bC4wNjYuMjMxIDUuMDc1IDIuOTM0VjcuMzg1QzIzLjQ2IDMuMzMgMjAuMTY2IDAgMTYuMDggMGE3LjM3IDcuMzcgMCAwIDAtNy4zODEgNy4zODV2MTMuNTgybDUuMDQxLTIuOTAxeiIvPjxwYXRoIGQ9Ik0xNy44OTIgMTguODlsLTkuMzI1IDUuMzc0YTIuNDAzIDIuNDAzIDAgMCAxLTEuMTUzLjI5NiAyLjM1MyAyLjM1MyAwIDAgMS0yLjAxLTEuMTUzIDIuMzcyIDIuMzcyIDAgMCAxLS4yMy0xLjc4Yy4wOTgtLjM5Ni4zMjktLjc5Mi42MjUtMS4wODlsLjE2NS0uMTY0di01LjgzNmwtMi4yNCAxLjI4NmE3LjIyOCA3LjIyOCAwIDAgMC0zLjQyNyA0LjQ4NGMtLjQ5NSAxLjkxMi0uMjY0IDMuODkuNzI0IDUuNjA0YTcuNDAyIDcuNDAyIDAgMCAwIDYuMzkzIDMuNjkyYzEuMjg1IDAgMi41Ny0uMzMgMy42OS0uOTg5bDExLjgzLTYuODI0LTUuMDQyLTIuOXoiLz48L2c+PC9nPjwvc3ZnPg==');
  background-size: cover;
`;

export const MainNavigationItemIcon = styled(Icon)`
  width: 32px;
  height: 32px;
  margin-right: 10px;
`;

export const MainNavigationItem = styled(NavLink)`
  display: flex;
  align-items: center;
  height: 100%;
  text-transform: uppercase;
  margin-left: 5%;
  font-size: 15px;
  padding: 20px 0;


  &.active {
    border-bottom: 4px solid ${props => props.theme.colors.brandPrimary};

    ${MainNavigationItemIcon} {
      color: ${props => props.theme.colors.brandPrimary};
    }
  }

  @media ${Devices.tablet} {
    margin-left: 2%;
    padding: 10px 0;
  }
`;

export const MainNavigationBar = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-grow: 1;
  flex-wrap: wrap;
  align-items: center;
  background-color: #343434;
  color: ${transparentize(0.2, '#fff')};
`;

export const NavigationBarContainer = styled.div`
  position: relative;
  z-index: 1100;
  box-shadow: 0 2px 4px ${transparentize(0.9, '#000')};
`;
